import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Account from './Account';
import Core from './Core';

const ContactForm = forwardRef(({contact, fields = 'core', onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  const getFields = useCallback(() => {
    switch (fields) {
      case 'account':
        return Account;
      case 'core':
      default:
        return Core;
    }
  }, [fields]);

  return (
    <BaseForm
      ref={formRef}
      entity={contact}
      type="contact"
      fieldsComponent={useCallback((props) => {
        const Fields = getFields();
        return <Fields {...props}/>
      }, [getFields])}
      onSave={useCallback((data) => (
        services.contact.saveContact({
          ...(contact?.id ? {id: contact.id} : {}),
          ...getFields().onSave(data)
        })
      ), [services, contact, getFields])}
      onSaved={onSaved}
    />
  );
});

export default ContactForm;
